import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetCoreEntity as GetCoreEntityQuery,
    GetCoreEntityVariables as GetCoreEntityQueryVariables,
} from 'nutshell-graphql-types';

import GET_CORE_ENTITY from './graphql/queries/get-core-entity.graphql';

export const useGetEntity = (entityId: string) => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetCoreEntityQuery, GetCoreEntityQueryVariables>(GET_CORE_ENTITY, {
        variables: {id: entityId},
        fetchPolicy: 'cache-and-network',
    });

    const coreEntity = data ? data.coreEntity : null;

    return {
        isLoading,
        entity: coreEntity,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
